import { CategoryNavigation } from '#/components/layout/CategoryNavigation';
import { ContentLayout } from '#/components/layout/ContentLayout';
import { DevSpacer } from '#/components/layout/DevSpacer';
import {
  INTERIOR_NAV_CTA,
  INTERIOR_NAV_PRODUCT_TYPES,
  INTERIOR_NAV_SECTORS,
} from '#/lib/category-navigation';

import { NotFound } from './NotFound';

interface FullPageNotFoundProps {
  message?: string;
  buttonLabel?: string;
}

export function FullPageNotFound({
  message,
  buttonLabel,
}: FullPageNotFoundProps) {
  return (
    <>
      <DevSpacer />
      <CategoryNavigation
        productTypes={INTERIOR_NAV_PRODUCT_TYPES}
        sectors={INTERIOR_NAV_SECTORS}
        cta={INTERIOR_NAV_CTA}
        enableSearchPreview
      />
      <ContentLayout>
        <div className="col-content py-16">
          <NotFound message={message} buttonLabel={buttonLabel} />
        </div>
      </ContentLayout>
    </>
  );
}
